import React, { useEffect, useState, useContext } from "react";
import {
    Button,
    Modal,
    Form as AntForm,
    message,
    Tooltip,
    Tag,
    Card,
} from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { BiSpreadsheet } from "react-icons/bi";
import { MainTable, CustomerImages, PrintComponent } from "components";
import { instance } from "utils/axios";
import moment from "moment";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import ls from "utils/ls";

import { AuthContext } from "contexts";
import FilterForm from "./FilterForm";
import columns, { columnNames } from "./columns";
// import BookingDetail from "../booking/bookingDetail";

function BookingSearch() {
    const authContext = useContext(AuthContext);
    const { action } = authContext;
    const profile = authContext.state.userInfo.profile;
    const role = profile.role;
    const userId = profile.id;
    const selectedHostpital = 2;

    // ── Filter state ─────────────────────────────────────────────────────────
    const initialFilter = {
        startdate: null,
        enddate: null,
        painful: "",
        response: "",
        descr: "",
        answerPhone: "",
        receptionNote: "",
        customerName: "",
        regno: "",
        mobile: "",
        gender: -1,
        ageFrom: null,
        ageTo: null,
        servicetype: -1,
        serviceId: -1,
        doctorId: -1,
        technicianId: -1,
        receptionId: -1,
        ceitemid: -1,
        status: -1,
        isCe: -1,
        isAns: -1,
        urgent: -1,
        isRepeat: -1,
        insurance: -1,
        isEnglishResponse: -1,
        isBonus: -1,
    };
    const [filters, setFilters] = useState(initialFilter);
    const [searched, setSearched] = useState(false);

    // ── Result/UI state ─────────────────────────────────────────────────────
    const [data, setData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [hiddenColumns, setSetHiddenColumns] = useState(
        ls.get("bs_hiddenColumns") ?? []
    );

    // ── Selectable masters ──────────────────────────────────────────────────
    const [serviceTypes, setServiceTypes] = useState([
        { label: "Бүгд", value: -1 },
    ]);
    const [services, setServices] = useState([{ label: "Бүгд", value: -1 }]);
    const [doctors, setDoctors] = useState([{ label: "Бүгд", value: -1 }]);
    const [technicians, setTechnicians] = useState([
        { label: "Бүгд", value: -1 },
    ]);
    const [receptions, setReceptions] = useState([{ label: "Бүгд", value: -1 }]);
    const [ceItems, setCeItems] = useState([{ label: "Бүгд", value: -1 }]);

    // ── Detail / Print / Image modals ───────────────────────────────────────
    const [detailData, setDetailData] = useState(null);
    const [detailLoading, setDetailLoading] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [editData, setEditData] = useState(null);
    const [openPrint, setOpenPrint] = useState(false);
    const [openImage, setOpenImage] = useState(false);
    const [openImageId, setImageId] = useState(null);

    const [modal, contextHolder] = Modal.useModal();
    const [messageApi, messageHolder] = message.useMessage();

    const LIMIT = 200;

    // ── Sidebar key ──────────────────────────────────────────────────────────
    useEffect(() => {
        action.handleSidebarKey("booking-search");
    }, []);

    // ── Master data load ─────────────────────────────────────────────────────
    useEffect(() => {
        // Төхөөрөмж
        instance({ method: "get", url: `/servicetype?active=1` })
            .then((res) => {
                const arr = (res.data || [])
                    .filter((x) => x.id != 3)
                    .map((it) => ({ label: it.name, value: it.id, text: it.name }));
                setServiceTypes([{ label: "Бүгд", value: -1 }, ...arr]);
            })
            .catch((e) => console.error("servicetype load failed", e));

        // ✅ ЗАСВАР: /services → /service?hospital=...
        instance({
            method: "get",
            url: `/service?hospital=${selectedHostpital}`,
        })
            .then((res) => {
                const arr = (res.data || []).map((it) => ({
                    label: it.name,
                    value: it.id,
                    servicetypeid: it.servicetypeid,
                }));
                setServices([{ label: "Бүгд", value: -1 }, ...arr]);
            })
            .catch((e) => console.error("service load failed", e));

        // Эмч
        instance({
            method: "get",
            url: `/systemusers?role=Эмч&status=Идэвхитэй&hospital=${selectedHostpital}`,
        })
            .then((res) => {
                const arr = (res.data || []).map((it) => ({
                    label: `${it.lastname?.charAt(0) ?? ""}. ${it.firstname}`,
                    value: it.id,
                }));
                setDoctors([{ label: "Бүгд", value: -1 }, ...arr]);
            })
            .catch((e) => console.error("doctor load failed", e));

        // Техникч
        instance({
            method: "get",
            url: `/systemusers?role=Техникч&status=Идэвхитэй&hospital=${selectedHostpital}`,
        })
            .then((res) => {
                const arr = (res.data || []).map((it) => ({
                    label: `${it.lastname?.charAt(0) ?? ""}. ${it.firstname}`,
                    value: it.id,
                }));
                setTechnicians([{ label: "Бүгд", value: -1 }, ...arr]);
            })
            .catch((e) => console.error("technician load failed", e));

        // Ресейпшн
        instance({
            method: "get",
            url: `/systemusers?role=Ресейпшн&status=Идэвхитэй&hospital=${selectedHostpital}`,
        })
            .then((res) => {
                const arr = (res.data || []).map((it) => ({
                    label: `${it.lastname?.charAt(0) ?? ""}. ${it.firstname}`,
                    value: it.id,
                }));
                setReceptions([{ label: "Бүгд", value: -1 }, ...arr]);
            })
            .catch((e) => console.error("reception load failed", e));

        // ✅ ЗАСВАР: /ceitem → /ceitems, мөн serviceTypeId (camelCase)
        instance({ method: "get", url: `/ceitems` })
            .then((res) => {
                const arr = (res.data || []).map((it) => ({
                    label: it.name,
                    value: it.id,
                    servicetypeid: it.serviceTypeId, // ← camelCase-аас map хийнэ
                }));
                setCeItems([{ label: "Бүгд", value: -1 }, ...arr]);
            })
            .catch((e) => console.error("ceitem load failed", e));
    }, []);

    // ── Pagination өөрчлөгдсөн үед дахин fetch ───────────────────────────────
    useEffect(() => {
        if (searched) fetchData();
    }, [currentPage]);

    // ── Хайх ────────────────────────────────────────────────────────────────
    const buildQuery = () => {
        const q = new URLSearchParams();
        q.append("offset", currentPage);
        q.append("limit", LIMIT);
        q.append("hospital", selectedHostpital);

        Object.entries(filters).forEach(([k, v]) => {
            if (v == null || v === "" || v === -1) return;
            if (k === "startdate" || k === "enddate") {
                q.append(k, moment(v).format("YYYY-MM-DDTHH:mm:ss"));
            } else {
                q.append(k, v);
            }
        });
        return q.toString();
    };

    const fetchData = () => {
        setLoading(true);
        setSearched(true);
        instance({
            method: "get",
            url: `/customerbooking/search?${buildQuery()}`,
        })
            .then((res) => {
                setTotalCount(res.data.count ?? 0);
                setData(res.data.rows ?? []);
            })
            .catch((err) => {
                console.error("search failed", err);
                messageApi.error("Хайлт хийхэд алдаа гарлаа");
            })
            .then(() => setLoading(false));
    };

    const handleSearch = () => {
        setCurrentPage(0);
        fetchData();
    };

    const handleClear = () => {
        setFilters(initialFilter);
        setData([]);
        setTotalCount(0);
        setSearched(false);
        setCurrentPage(0);
    };

    const handleColumnChange = (val) => {
        setSetHiddenColumns(val);
        ls.set("bs_hiddenColumns", val);
    };

    // ── Row нээх (дэлгэрэнгүй) ───────────────────────────────────────────────
    const handleMore = (row) => {
        setDetailLoading(true);
        setSelectedCustomer(row);
        setShowDetail(true);
        instance({
            method: "get",
            url: `/customerbooking/${row.id}`,
        })
            .then((res) => setDetailData(res.data))
            .catch(() => { })
            .then(() => setDetailLoading(false));
    };

    // ── Excel export ─────────────────────────────────────────────────────────
    const exportToExcel = () => {
        if (!data.length) {
            messageApi.warning("Экспортлох мэдээлэл алга");
            return;
        }
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";

        const exportData = data.map((it, i) => ({
            "№": i + 1,
            Огноо: it.currentDate
                ? moment(it.currentDate).format("YYYY-MM-DD HH:mm")
                : "",
            "Овог нэр": it.customerFirstname,
            Регистр: it.regno,
            Нас: it.age,
            Хүйс: it.gender == 1 ? "Эр" : "Эм",
            Утас: it.answerPhone,
            Зовиур: it.painful,
            Үйлчилгээ: it.serviceNames,
            Төхөөрөмж: it.serviceTypeName,
            Эмч: it.doctor,
            Техникч: it.technicalUser,
            Ресейпшн: it.reception,
            Тодосгогч: it.isCe ? "Тийм" : "",
            Унтуулга: it.isAns ? "Тийм" : "",
            Яаралтай: it.urgent ? "Тийм" : "",
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = { Sheets: { Хайлт: ws }, SheetNames: ["Хайлт"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(
            blob,
            `Booking_search_${moment().format("YYYYMMDD_HHmm")}${fileExtension}`
        );
    };

    // ──────────────────────────────────────────────────────────────────────────
    return (
        <div className="p-4">
            {contextHolder}
            {messageHolder}

            <Card
                size="small"
                title={
                    <span className="font-semibold">
                        <SearchOutlined /> Дэлгэрэнгүй хайлт
                    </span>
                }
                className="mb-3"
                extra={
                    <div className="flex items-center gap-2">
                        <Button
                            type="primary"
                            icon={<SearchOutlined />}
                            onClick={handleSearch}
                            loading={loading}
                        >
                            Хайх
                        </Button>
                        <Button icon={<ClearOutlined />} onClick={handleClear}>
                            Цэвэрлэх
                        </Button>
                        {/* <Tooltip title="Excel татах">
                            <Button
                                type="primary"
                                ghost
                                onClick={exportToExcel}
                                disabled={!data.length}
                            >
                                <BiSpreadsheet />
                            </Button>
                        </Tooltip> */}
                    </div>
                }
            >
                <FilterForm
                    filters={filters}
                    setFilters={setFilters}
                    serviceTypes={serviceTypes}
                    services={services}
                    doctors={doctors}
                    technicians={technicians}
                    receptions={receptions}
                    ceItems={ceItems}
                    onSearch={handleSearch}
                />
            </Card>

            <MainTable
                dataTable={data}
                columns={columns({
                    currentPage,
                    searchText: filters.painful || filters.customerName || filters.regno,
                    hiddenColumns,
                    handleMore,
                    openPrint: (row) => {
                        setEditData({
                            hospitalId: row.hospitalId,
                            name: row.customerFirstname,
                            currentDate: row.currentDate,
                            serviceName: `${row.serviceNames}${row.isCe ? "+CE" : ""} /${row.serviceTypeName
                                }/`,
                        });
                        setOpenPrint(true);
                    },
                    openImage: (bookingId) => {
                        setImageId(bookingId);
                        setOpenImage(true);
                    },
                }).filter((c) => c.visible !== false)}
                setCurrentPage={setCurrentPage}
                loading={loading}
                scroll={{ y: "calc(100vh - 480px)" }}
                pagination={{ total: totalCount }}
                pageSize={LIMIT}
                title={
                    searched ? (
                        <span>
                            Хайлтын үр дүн{" "}
                            <Tag color="blue">{totalCount.toLocaleString()} мөр</Tag>
                        </span>
                    ) : (
                        "Хайлт хийнэ үү"
                    )
                }
                hiddenColumns={hiddenColumns}
                handleColumnChange={handleColumnChange}
                columnNames={columnNames}
            />

            {/* Дэлгэрэнгүй */}
            {/* <BookingDetail
                showDetail={showDetail}
                setShowDetail={setShowDetail}
                detailData={detailData}
                detailLoading={detailLoading}
                selectedCustomer={selectedCustomer}
            /> */}

            {/* Хэвлэх */}
            <Modal
                open={openPrint}
                onCancel={() => setOpenPrint(false)}
                footer={null}
                width={800}
                destroyOnClose
            >
                {editData && <PrintComponent data={editData} />}
            </Modal>

            {/* Зураг */}
            <Modal
                open={openImage}
                onCancel={() => setOpenImage(false)}
                footer={null}
                width={1000}
                destroyOnClose
            >
                {openImageId && <CustomerImages bookingId={openImageId} />}
            </Modal>
        </div>
    );
}

export default BookingSearch;